function getWhatsAppNumber() {
  return (
    process.env.REACT_APP_WHATSAPP_PHNO ||
    process.env.REACT_APP_PHNO ||
    ""
  ).replace(/[^\d]/g, "");
}

export function buildWhatsAppUrl(message = ""): string {
  const whatsappNumber = getWhatsAppNumber();

  if (!whatsappNumber) {
    return "#";
  }

  const encodedMessage = encodeURIComponent(message);

  return message
    ? `https://wa.me/${whatsappNumber}?text=${encodedMessage}`
    : `https://wa.me/${whatsappNumber}`;
}

export const sendWhatsAppMessage = (message: string): void => {
  const whatsappUrl = buildWhatsAppUrl(message);

  if (whatsappUrl === "#") {
    return;
  }

  window.open(whatsappUrl, "_blank", "noopener,noreferrer");
};
